import Pathes from '@/helpers/pathes';
import axios from '@/axios-api';
import { getQuery } from '@/helpers/utils';

export const loanService = {
  list: params => axios.get(Pathes.Loans.list + getQuery(params)),
  refinBannerStatus: () => axios.get(Pathes.Loans.refinBannerStatus),
  refinApply: payload => axios.post(Pathes.Loans.refinApply, payload),
  refinAvailableLoans: params => axios.get(Pathes.Loans.availableRefinLoans + getQuery(params)),
  personalGuarantees: params => axios.get(Pathes.Loans.personalGuarantees + getQuery(params)),
  paymentSchedule: fundraisingId => axios.get(Pathes.Loans.paymentSchedule(fundraisingId)),
  shiftPayment: (fundraisingId, payload) =>
    axios.post(Pathes.Loans.shiftPayment(fundraisingId), payload),
  lenderList: params => axios.get(Pathes.Loans.lenderList + getQuery(params)),
  lenderLoanDetail: fundraisingId => axios.get(Pathes.Loans.detail(fundraisingId)),
};
